import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Link } from 'react-router-dom'
import Img1 from '../assets/images/landing-page/Img1.webp'
import Img2 from '../assets/images/landing-page/Img2.webp'
import Img3 from '../assets/images/landing-page/Img3.webp'
import { CheckLg, CircleFill } from 'react-bootstrap-icons'
import Icon1 from '../assets/images/landing-page/1.webp'
import Icon2 from '../assets/images/landing-page/2.webp'
import Icon3 from '../assets/images/landing-page/3.webp'
import Icon4 from '../assets/images/landing-page/4.webp'
import BannerImg from '../assets/images/landing-page/BannerBg.jpg'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'
import BgMiddle from '../assets/images/why-dubai/Img2.webp'
import axios from 'axios'
import Accordion from 'react-bootstrap/Accordion'
import FAQsSection from '../components/FAQsSection'

const DubaiInvestment = () => {
    const [counterOn, setCounterOn] = useState(false)
    const [transactionData, setTransactionData] = useState()

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchTransactionData()
    }, [])

    const fetchTransactionData = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/transaction`)
            setTransactionData(data.result)
        } catch (error) {
            console.error('transaction data', error)
        }
    }

    const countDecimals = (value) => {
        if (!value) return 0
        const parts = value.toString().split('.')
        return parts.length > 1 ? parts[1].length : 0
    }

    const tDecimals = countDecimals(transactionData?.transaction)
    const pDecimals = countDecimals(transactionData?.property_sale)
    const uDecimals = countDecimals(transactionData?.unit_sold)

    // Initialize counter values
    const transactionVal = parseFloat(transactionData?.transaction) || 0
    const propertySaleVal = parseFloat(transactionData?.property_sale) || 0
    const unitSoldVal = parseFloat(transactionData?.unit_sold) || 0

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title> Dubai Property Investment Guidance | 800 Homes </title>
                <meta
                    name="description"
                    content="Explore Dubai property investment insights, top areas, and market trends with 800 Homes. Find the best properties to buy or rent across Dubai."
                />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Dubai Property Investment Guidance | 800 Homes" />
                <meta
                    property="og:description"
                    content="Explore Dubai property investment insights, top areas, and market trends with 800 Homes. Find the best properties to buy or rent across Dubai."
                />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content="https://800homes.ae/og.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:description"
                    content="Explore Dubai property investment insights, top areas, and market trends with 800 Homes. Find the best properties to buy or rent across Dubai."
                />
                <meta name="twitter:title" content="Dubai Property Investment Guidance | 800 Homes" />
                <meta name="twitter:image" content="https://800homes.ae/og.webp" />
            </Helmet>

            <section id="website-responsive" className="container-fluid px-0">
                <section
                    id="landing-page"
                    className="container-fluid bg-common-banner bg-home vh-100 px-0 position-relative"
                    style={{ backgroundImage: `url(${BannerImg})` }}
                >
                    <div
                        className="d-md-none position-absolute top-0 start-0 w-100 h-100"
                        style={{ backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1 }}
                    ></div>
                    <Header />
                    <div
                        className="d-flex flex-column mt-md-0 mt-5 justify-content-center text-center text-md-start"
                        style={{
                            height:
                                window.innerWidth <= 992
                                    ? 'calc(50vh - var(--header-height, 80px))'
                                    : 'calc(100vh - var(--header-height, 80px))',
                            position: 'relative',
                            zIndex: 2,
                        }}
                    >
                        <div id="common-banner" className="col-10 mx-auto ps-md-3">
                            <h1 id="landing-page-title" className="fw-500 text-white fs-home-banner lh-sm">
                                Dubai Property <br className="" /> Investment Made <br className="d-none d-md-block" />{' '}
                                Simple
                            </h1>
                        </div>
                        <div className="d-block d-md-none pt-4 col-7 mx-auto" style={{ fontSize: '10px' }}>
                            <Link
                                to="/properties-for-sale"
                                className="mb-3 d-block text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                            >
                                Explore Investment Opportunities
                            </Link>
                            <Link
                                to="/contact-us"
                                className="d-block text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                            >
                                Speak to an Advisor
                            </Link>
                        </div>
                        <div
                            className="pt-4 d-md-flex d-none justify-content-center justify-content-md-start flex-wrap gap-3 col-10 mx-auto ps-md-3"
                            style={{ fontSize: window.innerWidth <= 992 ? '15px' : '1vw' }}
                        >
                            <Link
                                to="/properties-for-sale"
                                className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                            >
                                Explore Investment Opportunities
                            </Link>
                            <Link
                                to="/contact-us"
                                className="text-decoration-none px-4 py-ss-2 text-white border border-1 border-white rounded-5"
                            >
                                Speak to an Advisor
                            </Link>
                        </div>
                    </div>
                </section>
                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-center align-items-center gy-5">
                        <div className="col-11 col-md-6 col-lg-5">
                            <h2 className="fs-ss-30 fw-600 text-white pb-4 pe-md-5 ">
                                Grow your wealth with expert-guided real estate opportunities in Dubai
                            </h2>

                            <div className="pb-4 text-white fs-ss-18 fw-300 col-md-10 lh-1-7em">
                                Dubai’s property market continues to outperform global investment hubs — and with 800
                                Homes, you gain a trusted partner who helps you invest with clarity, confidence, and
                                zero guesswork.
                            </div>
                            <div className="text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Contact for Detail
                                </Link>
                            </div>
                        </div>
                        <div className="col-11 col-md-5 px-5">
                            <img src={Img1} className="w-100" alt="Dubai Property Investment" />
                        </div>
                    </div>
                </section>

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <h2 className="pb-2 text-center text-white fs-ss-35 fw-500">
                        Why Dubai Is a Leading Real Estate Investment Hub
                    </h2>
                    <div className="pb-5 text-center text-white fs-ss-18 fw-300 col-md-10 mx-auto lh-1-7em">
                        Dubai has become one of the world’s most secure and rewarding real estate markets — attracting
                        global investors with its strong economy, tax-free income, world-class infrastructure, and
                        unprecedented rental demand.
                    </div>
                    <div className="row justify-content-center gy-4">
                        <div className="col-11 col-md-10 col-lg-3 border-ss-primary p-4 text-white">
                            <h3 className="fs-ss-24 pb-3 fw-300 text-ss-primary">
                                Why Dubai Property Investment Is Growing
                            </h3>
                            <div className="fs-ss-16 fw-300">
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>100% foreign ownership in designated freehold zones</div>
                                </div>
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>Consistent population growth and high occupancy rates</div>
                                </div>
                                <div className="d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>Government-led initiatives boosting long-term investor confidence</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-11 col-md-10 col-lg-3 border-ss-primary p-4 text-white mx-4">
                            <h3 className="fs-ss-24 pb-3 fw-300 text-ss-primary">
                                Key Drivers of the Dubai Real Estate Market
                            </h3>
                            <div className="fs-ss-16 fw-300">
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>Strong GDP growth and business-friendly policies</div>
                                </div>
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>Safe and regulated environment overseen by RERA and DLD</div>
                                </div>
                                <div className="d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>High rental yields compared to global cities</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-11 col-md-10 col-lg-3 border-ss-primary p-4 text-white">
                            <h3 className="fs-ss-24 pb-3 fw-300 text-ss-primary">
                                Benefits of Investing in Dubai Real Estate Today
                            </h3>
                            <div className="fs-ss-16 fw-300">
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>High ROI on both rental and capital gains</div>
                                </div>
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>Easy buying process for international investors</div>
                                </div>
                                <div className="pb-2 d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>Flexible payment plans for off-plan projects</div>
                                </div>
                                <div className="d-flex">
                                    <div className="">
                                        <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                    </div>{' '}
                                    <div>No property tax, no capital gains tax</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-center justify-content-lg-end text-md-center text-lg-start gy-4 align-items-center">
                        <div className="col-11 col-md-8 col-lg-5">
                            <div className="col-12 col-lg-10 mx-auto">
                                <div className="text-uppercase fw-500 pb-2 pb-md-4">
                                    <h2 className="fs-ss-30 text-white text-shadow-parent pb-4">
                                        Best Areas to Invest in Dubai Real Estate
                                    </h2>
                                </div>

                                <div className="pb-md-4 text-white fs-ss-18 fw-300 col-lg-10">
                                    <div className="pb-4">
                                        <h3 className="text-ss-primary fs-ss-20 fw-600">
                                            {' '}
                                            Top Investment Zones in Dubai{' '}
                                        </h3>
                                        <div className="lh-1-7em">
                                            <div className="d-flex justify-content-md-center justify-content-lg-start">
                                                <div className="fs-ss-15">
                                                    <CircleFill
                                                        className=" text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Dubai Marina
                                                </div>
                                                <div className="ms-2 fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Downtown Dubai
                                                </div>
                                            </div>
                                            <div className="justify-content-md-center justify-content-lg-start d-flex">
                                                <div className="fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Business Bay
                                                </div>
                                                <div className="ms-2">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Palm Jumeirah
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pb-4">
                                        <h3 className="text-ss-primary fs-ss-20 fw-600">
                                            {' '}
                                            High-Demand Residential Communities{' '}
                                        </h3>
                                        <div className="lh-1-7em">
                                            <div className="d-flex justify-content-md-center justify-content-lg-start">
                                                <div className="fs-ss-15">
                                                    <CircleFill
                                                        className=" text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Jumeirah Village Circle
                                                </div>
                                                <div className="ms-2 fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Arabian Ranches
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-md-center justify-content-lg-start">
                                                <div className="fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    MBR City
                                                </div>
                                                <div className="ms-2 fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Dubai Hills Estate
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="">
                                        <h3 className="text-ss-primary fs-ss-20 fw-600">
                                            {' '}
                                            Upcoming Areas with Strong ROI Potential{' '}
                                        </h3>
                                        <div className="lh-1-7em">
                                            <div className="d-flex justify-content-md-center justify-content-lg-start">
                                                <div className="fs-ss-15">
                                                    <CircleFill
                                                        className=" text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Dubai Creek Harbour
                                                </div>
                                                <div className="ms-2 fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Emaar South
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-md-center justify-content-lg-start">
                                                <div className="fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Town Square
                                                </div>
                                                <div className="ms-2 fs-ss-15">
                                                    <CircleFill
                                                        className="fs-ss-15 text-ss-primary flex-shrink-0 me-1"
                                                        style={{ fontSize: '8px' }}
                                                    />{' '}
                                                    Al Furjan
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-11 col-md-8 col-lg-6 px-0">
                            <img src={Img2} className="w-100" alt="Dubai real estate services showcase" />
                        </div>
                    </div>
                </section>

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />
                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section
                    className="container-fluid py-5 bg-fixed"
                    style={{
                        backgroundImage: `url(${BgMiddle})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: 'rgba(0,0,0,0.9)',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1,
                        }}
                    ></div>
                    <div className="py-5" style={{ position: 'relative', zIndex: 2 }}>
                        <h2 className="pb-2 text-center text-white fs-ss-35 fw-500">Market Insights From 800 Homes</h2>
                        <div className="pb-5 text-center text-white fs-ss-18 fw-300 col-md-10 mx-auto lh-1-7em">
                            We combine real-time data, market experience, and trend analysis to help investors make
                            smarter decisions.
                        </div>
                        <div className="row justify-content-center gy-4">
                            <div className="col-11 col-md-10 col-lg-3 border-ss-primary p-4 text-white">
                                <h3 className="fs-ss-24 pb-3 fw-300 text-ss-primary">
                                    Current Dubai Real Estate Market Trends
                                </h3>
                                <div className="fs-ss-16 fw-300">
                                    <div className="pb-2 d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Rising demand for both short-term and long-term rentals</div>
                                    </div>
                                    <div className="pb-2 d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Stable property prices with strong upward momentum</div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>High absorption rates across off-plan projects</div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-11 col-md-10 col-lg-3 border-ss-primary p-4 text-white mx-4">
                                <h3 className="fs-ss-24 pb-3 fw-300 text-ss-primary">
                                    Price Movements & Rental Yield Analysis
                                </h3>
                                <div className="fs-ss-16 fw-300">
                                    <div className="pb-2 d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Apartments yielding 6–9% annually</div>
                                    </div>
                                    <div className="pb-2 d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Villas delivering 5–7% ROI with strong long-term value</div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Steady growth driven by foreign investor influx</div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-11 col-md-10 col-lg-3 border-ss-primary p-4 text-white">
                                <h3 className="fs-ss-24 pb-3 fw-300 text-ss-primary">
                                    Predictions for the Next 12 Months
                                </h3>
                                <div className="fs-ss-16 fw-300">
                                    <div className="pb-2 d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Continued price appreciation in prime areas</div>
                                    </div>
                                    <div className="pb-2 d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Increased interest from European and GCC investors</div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="">
                                            <CheckLg className="fs-ss-22 text-ss-primary me-3 flex-shrink-0" />
                                        </div>{' '}
                                        <div>Higher demand for luxury, waterfront, and branded residences</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />
                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-center align-items-center gy-4">
                        <div className="col-11 col-lg-4 px-0 pb-4 pb-md-0">
                            <div className="col-11 text-md-center text-lg-start col-md-9 col-lg-10 mx-auto">
                                <h2 className="fs-ss-48 fw-600 text-white pb-md-4">
                                    Dubai Property <br className="d-none d-lg-block" /> Investment{' '}
                                    <br className="d-none d-lg-block" /> Opportunities
                                </h2>
                                <div className="text-white fs-ss-18 fw-400 d-none d-md-block mb-md-4 mb-lg-0">
                                    <Link
                                        to="/properties-for-sale"
                                        className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                    >
                                        Explore Properties
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-11 col-md-10 col-lg-6">
                            <div className="row justify-content-center gy-4">
                                <div className="col-11 col-md-5 border-ss-primary-hover text-center p-4 me-md-4">
                                    <img src={Icon1} className="w-icons mb-4" alt="Off-Plan Investment icon" />
                                    <div className="pb-2 fs-ss-18 fw-500 text-white">Off-Plan Investment Options</div>
                                    <div className="fs-ss-16 fw-300 text-grey">
                                        Secure pre-launch units with attractive payment plans
                                    </div>
                                </div>

                                <div className="col-11 col-md-5 border-ss-primary-hover text-center p-4">
                                    <img src={Icon2} className="w-icons mb-4" alt="Luxury Properties icon" />
                                    <div className="pb-2 fs-ss-18 fw-500 text-white">
                                        Luxury & Waterfront Properties
                                    </div>
                                    <div className="fs-ss-16 fw-300 text-grey">
                                        Premium villas in exclusive communities
                                    </div>
                                </div>

                                <div className="col-11 col-md-5 border-ss-primary-hover text-center p-4 me-md-4">
                                    <img src={Icon3} className="w-icons mb-4" alt="Affordable Properties icon" />
                                    <div className="pb-2 fs-ss-18 fw-500 text-white">
                                        Affordable Investment Properties
                                    </div>
                                    <div className="fs-ss-16 fw-300 text-grey">
                                        Smart entry-level opportunities with strong demand
                                    </div>
                                </div>

                                <div className="col-11 col-md-5 border-ss-primary-hover text-center p-4">
                                    <img src={Icon4} className="w-icons mb-4" alt="Short-Term Rentals icon" />
                                    <div className="pb-2 fs-ss-18 fw-500 text-white">
                                        Short-Term Rentals & Holiday Homes
                                    </div>
                                    <div className="fs-ss-16 fw-300 text-grey">
                                        Airbnb-friendly properties with high yields
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />
                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <section className="container-fluid">
                    <div className="row justify-content-evenly align-items-center gy-5">
                        <div className="col-11 col-md-5 px-0 d-none d-lg-block">
                            <img src={Img3} className="w-100" alt="800 Homes real estate investment services" />
                        </div>
                        <div className="col-11 col-md-8 col-lg-5">
                            <h2 className="fs-ss-30 fw-600 text-white pb-4">
                                Why Choose 800 Homes for Dubai Real Estate Investment
                            </h2>
                            <div className="pb-4 text-white fs-ss-18 fw-300 col-md-10 lh-1-7em">
                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">Local Expertise Backed by Data</div>
                                </div>

                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">Personalized Property Matching</div>
                                </div>

                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">End-to-End Investment Support</div>
                                </div>

                                <div className="d-flex pb-2 pb-md-3">
                                    <div className="">
                                        <CheckLg className="fs-ss-30 text-ss-primary me-3" />
                                    </div>
                                    <div className="lh-1-7em">Transparent Guidance in Dubai's Real Estate Market</div>
                                </div>
                            </div>
                            <div className="text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Get in Touch
                                </Link>
                            </div>
                        </div>
                        <div className="col-11 col-md-5 px-0 d-block d-md-none">
                            <img src={Img3} className="w-100" alt="800 Homes investment services" />
                        </div>
                    </div>
                </section>

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />
                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                    <section id="numbers" className="container-lg">
                        <div className="row justify-content-center text-center px-md-5 gy-4">
                            <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">Dubai Real Estate Transactions</h2>

                            <div className="col-md border-white border-end border-1">
                                <div className="fs-ss-40 text-ss-primary fw-600">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={transactionVal}
                                            decimals={tDecimals}
                                            duration={4}
                                            delay={0}
                                        />
                                    )}
                                    {transactionData?.transaction_unit ? ` ${transactionData.transaction_unit}` : ''}
                                </div>
                                <div className="fs-ss-18 text-white">
                                    {`Total Transactions in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                                </div>
                            </div>

                            <div className="col-md border-white border-end border-1">
                                <div className="fs-ss-40 text-ss-primary fw-600">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={propertySaleVal}
                                            decimals={pDecimals}
                                            duration={4}
                                            delay={0}
                                        />
                                    )}
                                    {transactionData?.property_sale_unit
                                        ? ` ${transactionData.property_sale_unit}`
                                        : ''}
                                </div>
                                <div className="fs-ss-18 text-white">
                                    {`Property Sales in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                                </div>
                            </div>

                            <div className="col-md">
                                <div className="fs-ss-40 text-ss-primary fw-600">
                                    {counterOn && (
                                        <CountUp
                                            start={0}
                                            end={unitSoldVal}
                                            decimals={uDecimals}
                                            duration={4}
                                            delay={0}
                                        />
                                    )}
                                    {transactionData?.unit_sold_unit ? ` ${transactionData.unit_sold_unit}` : ''}
                                </div>
                                <div className="fs-ss-18 text-white">
                                    {`Units Sold in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                                </div>
                            </div>
                        </div>
                    </section>
                </ScrollTrigger>

                {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
          <section id="numbers" className="container-lg">
            <div className="row justify-content-center text-center px-md-5 gy-4">
              <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">
                Dubai Real Estate Transactions
              </h2>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={215346} decimals={0} duration={4} delay={0} />
                  )}
               
                </div>
                <div className="fs-ss-18 text-white">
                  Total Transactions in 2025
                </div>
              </div>

              <div className="col-md">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={686.8} decimals={pDecimals} duration={4} delay={0} />
                  )}
                  B
                </div>
                <div className="fs-ss-18 text-white">
                  Property Sales in 2025
                </div>
              </div>
            </div>
          </section>
        </ScrollTrigger> */}

                <section className="" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0 d-none d-md-block" />
                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                {/* FAQs About Dubai Property Investment */}
                <section id="website-responsive" className="container-lg text-white">
                    <div className="fs-ss-30 fw-600 fw-600 lh-sm text-center pb-4">
                        FAQs About Dubai Property Investment
                    </div>
                    <div className="row justify-content-center text-center">
                        <div className="col-11 col-md-8">
                            <Accordion defaultActiveKey={1} className="border-0">
                                <FAQsSection
                                    EvenyKey={1}
                                    Title="How can I start my Dubai property investment journey as a new investor?"
                                    Para="You can begin by sharing your budget and investment goals, after which you'll receive curated property options tailored to your needs. You can then book a viewing or virtual tour to explore the options. Once you've selected a property, you can secure it with a reservation, and our team will assist you with all documentation and approvals. After purchase, handover support and rental management services are also available."
                                />

                                <FAQsSection
                                    EvenyKey={2}
                                    Title="What Documents are Required for Foreign Investors?"
                                    Para="Foreign investors need to provide a passport copy, contact details, and proof of funds (optional depending on project) to complete their property investment in Dubai."
                                />

                                <FAQsSection
                                    EvenyKey={3}
                                    Title="What are the Finance & Mortgage Options in Dubai?"
                                    Para="We can connect you with UAE banks offering competitive mortgage rates and fast approvals to help finance your Dubai property investment."
                                />

                                <FAQsSection
                                    EvenyKey={4}
                                    Title="Is Dubai a good place for real estate investment?"
                                    Para="Yes. Dubai offers high rental yields, strong capital appreciation, and a stable, regulated market."
                                />

                                <FAQsSection
                                    EvenyKey={5}
                                    Title="What are the best areas to invest in Dubai real estate?"
                                    Para="Dubai Marina, Downtown, JVC, Business Bay, Dubai Creek Harbour, and Dubai Hills Estate."
                                />

                                <FAQsSection
                                    EvenyKey={6}
                                    Title="Can foreigners invest in Dubai property?"
                                    Para="Absolutely. Foreigners can own 100% of property in designated freehold zones."
                                />

                                <FAQsSection
                                    EvenyKey={7}
                                    Title="How stable is the Dubai real estate market?"
                                    Para="Dubai's market is backed by government regulations, strong demand, and a growing expat population."
                                />

                                <FAQsSection
                                    EvenyKey={8}
                                    Title="What is the average ROI on Dubai real estate?"
                                    Para="Apartments typically yield 6–9% annually, while villas deliver 5–7% ROI with strong long-term value."
                                />
                            </Accordion>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                {/* Final Call to Action */}
                <section className="container-fluid">
                    <div className="row justify-content-center text-center ">
                        <div className="col-11 col-md-9 py-5">
                            <div className="">
                                <h2 className="fs-ss-35 fw-600 pb-1 text-ss-primary">
                                    Ready to invest in Dubai with confidence?
                                </h2>
                                <p className="text-white fs-ss-18 fw-300 pb-4">
                                    Let our experts guide you toward the most profitable opportunities.
                                </p>
                                <div className="text-white fs-ss-18 fw-400">
                                    <Link
                                        to="/contact-us"
                                        className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                    >
                                        Book a Free Consultation
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                {/* Mobile Space */}
                <section className="pt-4 pt-md-0" />

                <Footer />
            </section>
        </>
    )
}

export default DubaiInvestment
